<template>
	<div class="user">
		<basic-container>
			<el-row :span="24">
				<el-col :md="24" :sm="24" :xs="24" class="user__main">
					<avue-crud
						ref="crud"
						v-model="formData"
						:before-close="handleCloseBefore"
						:before-open="onHandleBeforeOpen"
						:cell-style="cellStyle"
						:data="list"
						:option="option"
						:page.sync="page"
						:table-loading="listLoading"
						@on-load="getList"
						@search-change="searchChange"
						@refresh-change="refreshChange"
						@size-change="sizeChange"
						@current-change="currentChange"
						@row-update="update"
						@row-save="create">
						<template slot="menuLeft">
							<el-button
								v-if="team_staff_add && isShowAdd"
								class="filter-item"
								icon="el-icon-edit"
								size="small"
								type="primary"
								@click="$refs.crud.rowAdd()">
								添加
							</el-button>
						</template>
						<template slot="userName" slot-scope="scope">
							<span>{{ scope.row.userName }}</span>
						</template>
						<template slot="loginName" slot-scope="scope">
							<span>{{ scope.row.loginName }}</span>
						</template>
						<template slot="mobile" slot-scope="scope">
							<span>{{ scope.row.mobile }}</span>
						</template>
						<!-- <template
              slot="status"
              slot-scope="scope">
              <el-tag>{{ scope.label }}</el-tag>
            </template> -->
						<template slot="createAt" slot-scope="scope">
							<span>{{ scope.row.createAt }}</span>
						</template>
						<template slot="menu" slot-scope="scope">
							<el-button
								v-if="team_staff_edit"
								icon="el-icon-edit"
								size="small"
								type="text"
								@click="handleUpdate(scope.row, scope.index)">
								编辑
							</el-button>
							<el-button
								v-if="team_staff_del"
								icon="el-icon-delete"
								size="small"
								type="text"
								@click="deletes(scope.row, scope.index)">
								删除
							</el-button>
						</template>
					</avue-crud>
				</el-col>
			</el-row>
		</basic-container>
	</div>
</template>

<script>
import {addObj, delObj, fetchList, putObj} from '@/api/team/staff'
import {tableOption} from '@/const/crud/team/staff'
import {mapGetters} from 'vuex'
import {rule} from '@/util/validateRules'
import {getChannelMainInfo} from '@/api/insurance/policy'
import {decryptMessageByObject} from '@/util/secret'

export default {
	name: 'TeamStaff',
	data() {
		return {
			searchForm: {},
			treeOption: {
				nodeKey: 'id',
				addBtn: false,
				menu: false,
				props: {
					label: 'name',
					value: 'id',
				},
			},
			treeData: [],
			option: tableOption,
			checkedKeys: [],
			defaultProps: {
				label: 'name',
				value: 'id',
			},
			page: {
				total: 0, // 总页数
				currentPage: 1, // 当前页数
				pageSize: 20, // 每页显示多少条,
				pageSizes: [10, 20, 30, 40, 50, 100, 1000],
				isAsc: false, // 是否倒序
			},
			list: [],
			listLoading: true,
			formData: {},
			// initPass: '',

			editShowing: false,
			isShowAdd: true,
		}
	},
	computed: {
		...mapGetters(['permissions', 'userInfo']),
	},
	// watch: {
	//   role() {
	//     this.formData.role = this.role
	//   }
	// },
	watch: {
		'formData.changepassword'(val, oldVal) {
			if (this.editShowing === true) {
				let password = this.findObject(this.option.column, 'password')
				if (val === 1) {
					password.rules = [{required: true, validator: rule.validatorPass, trigger: 'blur'}]
					password.editDisabled = false
					this.formData.password = undefined
				} else {
					password.rules = [{required: false, validator: null, trigger: 'blur'}]
					password.editDisabled = true
					if (oldVal === 1) {
						this.$nextTick(() => {
							if (this.$refs.crud) {
								// 只清除清除验证
								this.$refs.crud.clearValidate()
							}
						})
					}
				}
			}
		},
	},

	created() {
		this.team_staff_add = this.permissions['dist_distAccount_add']
		this.team_staff_edit = this.permissions['dist_distAccount_edit']
		this.team_staff_del = this.permissions['dist_distAccount_del']
		this.initData()
	},
	methods: {
		async initData() {
			let {distAccount = {}} = this.userInfo
			let {channelId = '', mainChannelId = ''} = distAccount
			if (mainChannelId !== '' && channelId === mainChannelId) {
				//主渠道 获取渠道信息
				let resultData = (await getChannelMainInfo()) || {}
				let {code = -1, data = {}} = resultData.data
				if (code === 0) {
					let {limitAddAccount = 0} = data
					this.isShowAdd = limitAddAccount === 0
				}
			}
		},
		getList(page, params) {
			this.listLoading = true
			fetchList(
				Object.assign(
					{
						role: 6, // 只查询内勤角色
						current: page.currentPage,
						size: page.pageSize,
					},
					params,
					this.searchForm,
				),
			).then((response) => {
				this.list = response.data.data.records
				this.page.total = response.data.data.total
				this.listLoading = false
			})
		},
		searchChange(param, done) {
			this.searchForm = param
			this.page.currentPage = 1
			this.getList(this.page, param)
			done()
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize
		},
		currentChange(current) {
			this.page.currentPage = current
		},
		refreshChange() {
			this.getList(this.page)
		},
		async onHandleBeforeOpen(show, type) {
			window.boxType = type
			let formData = await decryptMessageByObject(this.formData)
			Object.assign(this.formData, formData)

			let password = this.findObject(this.option.column, 'password')

			if (['edit', 'views'].includes(type)) {
				password.rules = [{required: false, validator: rule.validatorPass, trigger: 'blur'}]
				sessionStorage.setItem('validHasBeenPresence_edit', JSON.stringify({type: '1', value: this.formData.id}))
				this.editShowing = true
				password.span = 8
			} else if (type === 'add') {
				sessionStorage.removeItem('validHasBeenPresence_edit')
				password.rules = [{required: true, validator: rule.validatorPass, trigger: 'blur'}]
				this.editShowing = false
				password.span = 12
			}

			show()
		},
		handleCloseBefore(done, type) {
			// if (type === 'add') {
			//   this.$message({
			//     type: 'success',
			//     message: '登录名和初始密码已复制到系统剪贴板'
			//   })
			// }
			done()
		},
		handleUpdate(row, index) {
			this.$refs.crud.rowEdit(row, index)
			this.formData.password = undefined
		},
		cellStyle({row, column, rowIndex, columnIndex}) {
			if (columnIndex == 4) {
				if (row.status == 0) {
					return {
						color: 'red',
					}
				}
			}
		},
		create(row, done, loading) {
			if (this.formData.phone && this.formData.phone.indexOf('*') > 0) {
				this.formData.phone = undefined
			}
			// Added by Li Yong on 2021/09/05
			// 新增渠道管理员账户默认为需重置密码状态
			this.formData.passwordStatus = 1
			// 如果手机号不存在，则删除属性
			if (!this.formData.mobile) {
				this.$delete(this.formData, 'mobile')
			}
			//
			addObj(this.formData)
				.then(() => {
					this.getList(this.page)
					done()
					this.$notify.success('创建成功')
				})
				.catch(() => {
					loading()
				})
		},
		update(row, index, done, loading) {
			if (this.formData.phone && this.formData.phone.indexOf('*') > 0) {
				this.formData.phone = undefined
			}
			//如果没有手机号，则去除
			if (this.validatenull(this.formData.mobile)) {
				this.formData.mobile = undefined
			}
			// Added by Li Yong on 2021/09/05
			this.formData.passwordStatus = this.formData.changepassword === 1 ? 1 : 0
			//
			putObj(this.formData)
				.then(() => {
					this.getList(this.page)
					done()
					this.$notify.success('修改成功')
				})
				.catch(() => {
					loading()
				})
		},
		deletes(row, index) {
			this.$confirm('此操作将永久删除该用户(用户名:' + row.userName + '), 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				delObj(row.id)
					.then(() => {
						this.list.splice(index, 1)
						this.$notify.success('删除成功')
					})
					.catch(() => {
						this.$notify.error('删除失败')
					})
			})
		},
		// randPass(len) {
		//   var allChars = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z',
		//   'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z',
		//   '0','1','2','3','4','5','6','7','8','9']

		//   var passArrayLen = allChars.length
		//   var password = ""

		//   for (var i = 0; i < len; i++) {
		//     var pos = Math.floor(Math.random() * passArrayLen);
		//     password += allChars[pos];
		//   }

		//   this.initPass = password
		// }
	},
}
</script>
<style lang="scss">
.user {
	height: 100%;

	&__tree {
		padding-top: 3px;
		padding-right: 20px;
	}
}
</style>
